import { exeRequest } from '../utils/APIUtils';

const toQS = (obj = {}) => {
    const q = Object.entries(obj)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
    return q ? `?${q}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // ⬇️ maintenant avec filtres/pagination: { page, limit, start, end, q, sort }
    listeDesChauffeursQuiOntActivePromoDimanche: async (params = {}) => exeRequest(`/admin/liste-promotions-dimanche${toQS(params)}`, "GET"),

    statsPromotionsDimanche: async (periode = 'jour') => exeRequest(`/admin/stats-promotions-dimanche?periode=${periode}`, "GET"),
};
